export default "__VITE_ASSET__A4s15tWR__"